<template>
  <div class="mt-4">
    <div v-for="(item, index) in items" :key="index + key">
      <v-row no-gutters>
        <v-col cols="10">
          <v-text-field v-model="item.value" class="ml-2" label="Clause"></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn text icon color="error" @click="didRemove(index)">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <v-btn dark color="teal" @click="didAdd">Add Clause +</v-btn>
  </div>
</template>

<script>
export default {
  props: {
    items: Array
  },
  data: () => ({
    key: Date.now()
  }),
  methods: {
    didAdd () {
      this.$emit('didAdd')
    },
    didRemove (index) {
      this.$emit('didRemove', index)
    }
  }
}
</script>
